import Header from './components/Header';
import Hero from './components/Hero';
import Updates from './components/Updates';
import Comments from './components/Comments';
import Ranking from './components/Ranking';
import Topics from './components/Topics';
import IndexSection from './components/IndexSection';
import About from './components/About';
import Contact from './components/Contact';
import Features from './components/Features';
import Carousel from './components/Carousel';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import Cards from './components/Cards';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Updates />
        <Comments />
        <Ranking />
        <Topics />
        <IndexSection />
        <About />
        <Contact />
        <Features />
        <Carousel />
        <MediaSection />
        <AppSection />
        <Cards />
        <Faq />
      </main>
      <Footer />
    </>
  );
}